const mapper = () => {
    const toList = (docs) => {
      let newResults = []
      docs.forEach(doc => {
        let newResult = doc.data()
        newResult.id = doc.id
        newResults.push(newResult)
      })
      return newResults
    }

    const toMap = (docs) => {
      let newResults = {}
      docs.forEach(doc => {
        newResult[doc.id] = doc.data()
      })
      return newResults
    }

    const get = (doc) => {
      const data = doc.data()
      return {
        ...data,
        id: doc.id
      }
    }
  
    return Object.freeze({
      toList, toMap, get
    })
  }

  const DefaultMapper = mapper()
  
  export default DefaultMapper